import React from "react"
import PropTypes from "prop-types"
import {Check} from "react-bootstrap-icons"
import Typography from "../../reusable/Typography/Typography"

type Props = {
    number: number
    label: string
    active?: boolean
    past?: boolean
}

const dimensions = 36

const Step: React.FC<Props> = ({number, label, active, past}) => {
	return (
		<div style={{
			width: dimensions,
			height: dimensions,
			lineHeight: `${dimensions}px`
		}}
		className={`border border-2 rounded-circle text-center text-bold position-relative ${active ? "border-success text-success" : "text-secondary"}`}>
			{past ? <Check size={22}/> : number}
			<div className={"text-center position-absolute start-0 end-0 text-dark"}
				style={{
					marginLeft: "-100%",
					marginRight: "-100%",
					top: "100%"
				}}>
				<Typography variant="bodyLg"
					semanticTag="span">{label}</Typography>
			</div>
		</div>
	)
}

Step.propTypes = {
	number: PropTypes.number.isRequired,
	label: PropTypes.string.isRequired,
	active: PropTypes.bool,
	past: PropTypes.bool
}

export default Step
